import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';

import { apiPaths } from '../../../../service/apiPaths';
import ApiService from '../../../../service/ApiService';
import { limit } from '../../../../util/constant';
import { ILeave } from './Leave.props';

interface ILeaveView {
  _id: string;
  name: string;
  description: string;
  status: string;
  totalHours: number;
  users: Array<{
    name: string;
    email: string;
    role: string;
    totalHours: number;
    dateWise: Array<{
      date: string;
      hours: number;
    }>;
  }>;
}

const useLeave = () => {

  const [leaveData, setLeaveData] = useState<ILeave[]>([]);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [selectedId, setSelectedId] = useState<any>();
  const [description, setDescription] = useState<string>("");

  const handleDateFilter = async (
    fromDate: Date | null,
    toDate: Date | null
  ) => {
    setLoading(true);
    try {
      let endpoint = ``;

      endpoint = `${apiPaths.getLeave}?status=pending&page=${page}&limit=${limit}`;

      const result = await ApiService({
        method: "GET",
        endpoint: endpoint,
      });
      setLeaveData(result?.leaves);
      setTotalPage(result.totalPages);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelStatusUp = () => {
    setShowConfirmation(false);
    setDeletingId(null);
  };

  const handleSelectStatus = (e: any, id: any) => {
    const status = e.target.value;
    if (status === "reject" || status === "approve") {
      setShowModal(true);
      setSelectedStatus(status);
      setSelectedId(id);
    } else {
      handleConfirmStatusUp(id, status, "");
    }
  };
  const handleConfirmStatusUp = async (
    id: any,
    status: any,
    description: string
  ) => {
    setLoading(true);
    
    const updateData: any = {
      status: status,
      comments: description,
    };
    
    // Get Slack channel from employee data (userId should be populated)
    const employeeSlackChannel = id.userId?.slackChannelId;
    
    if (employeeSlackChannel) {
      updateData.channel = employeeSlackChannel;
      console.log(`Sending Slack notification to: ${employeeSlackChannel}`);
    } else {
      console.warn("No Slack channel configured for this employee");
    }
    
    try {
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateLeaveRequest}${id._id}/status`,
        data: updateData,
      });
      
      const message = employeeSlackChannel 
        ? "Leave status updated and Slack notification sent"
        : "Leave status updated successfully";
      toast.success(message);
      handleDateFilter(null, null);
    } catch (error: any) {
      console.error("Error updating leave status:", error);
      toast.error(
        error?.response?.data?.message || "Error updating leave status"
      );
    } finally {
      setLoading(false);
    }
  };
  const handleModalSubmit = () => {
    handleConfirmStatusUp(selectedId, selectedStatus, description);
    setShowModal(false);
    setDescription("");
  };

  const handleModalClose = () => {
    setShowModal(false);
    setDescription("");
  };

  return {
    leaveData,
    showConfirmation,
    handleCancelStatusUp,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
    handleSelectStatus,
    showModal,
    handleModalClose,
    handleModalSubmit,
    description,
    setDescription,
    handleDateFilter
  };
};

export default useLeave;
